import React from 'react';
import '../styles/LetsCollaborate.css';

const LetsCollaborate = () => {
  const partners = ['Keysight EDA', 'AMD'];

  return (
    <section className="collaboration-section">
      <div className="collaboration-container">
        <div className="collaboration-header">
          <h2 className="collaboration-title">Let's Collaborate for Success</h2>
          <div className="title-underline"></div>
        </div>
        
        <div className="collaboration-content">
          <p className="collaboration-description">
            At Infinipoint Technologies, we believe that collaboration fuels progress. 
            By integrating our expertise with the powerful capabilities of {partners.map((partner, index) => (
              <span key={index}>
                {index === partners.length - 1 ? 
                  ` and ${partner}` : 
                  index === 0 ? partner : `, ${partner}`}
              </span>
            ))}, we help businesses achieve their goals with confidence and efficiency.
          </p>
          
          <p className="collaboration-cta">
            Get in touch today to explore how our partnerships can empower your business.
          </p>
          
          <button className="collaboration-button" onClick={() => window.location.href = '/contact'}>
            Contact Us
          </button>
        </div>
      </div>
    </section>
  );
};

export default LetsCollaborate;